module.exports = __webpack_public_path__ + "static/img/ag2.72f3d9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programs/ag2.jpg
// module id = PrkF
// module chunks = 1